import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import useDispatch from 'client/hooks/useDispatch';

import { SR_API_ACTION_SERVICE_AREA_INGEST_AREAS } from 'api/utilityActionTypes';

import { createInitialValues, createFormValidationFn } from 'client/helpers/formikHelpers';

import requestUtilityApi from 'client/actions/requestUtilityApi';

import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';

import SrButton, {
  SR_BUTTON_THEME_ADOBE_GREEN,
  SR_BUTTON_HEIGHT_MEDIUM,
} from 'client/components/SrButton/SrButton';

import SrBox from 'client/components/SrBox';

const getFormFields = ({ utilityTypes }) => [
  {
    id: 'utilityTypeId',
    type: 'select',
    title: 'Utility Type',
    properties: {
      choices: utilityTypes?.map(({ id, label }) => ({
        label: label,
        value: id,
      })),
    },
    validations: ['required'],
  },
  {
    id: 'geojsonFileUrl',
    title: 'GeoJSON File',
    type: 'short_text',
    validations: ['required'],
  },
];

const UPIngestServiceAreaForm = ({ utilityTypes, afterSubmit }) => {
  const dispatch = useDispatch();

  const onSubmit = (formValues, formikBag) => {
    const { utilityTypeId: utilityTypeIdStr, geojsonFileUrl } = formValues;

    dispatch(requestUtilityApi, {
      action: SR_API_ACTION_SERVICE_AREA_INGEST_AREAS,
      payload: {
        utilityTypeId: parseInt(utilityTypeIdStr, 10),
        geojsonFileUrl,
      },
      onSuccess() {
        formikBag.resetForm();
        global.alert('Service area data ingestion started.');

        if (afterSubmit) {
          afterSubmit();
        }
      },
      onError(error) {
        global.alert(error?.message);
      },
    });
  };

  const formFields = getFormFields({ utilityTypes });

  return (
    <Formik
      enableReinitialize
      initialValues={createInitialValues({ formFields })}
      validate={createFormValidationFn(formFields)}
      onSubmit={onSubmit}
      render={(formikBag) => (
        <Form>
          {formFields.map((formField) => (
            <SrFormikField
              key={formField.id}
              formField={formField}
              formikBag={formikBag}
              theme={SR_FIELD_THEME_ADOBE}
            />
          ))}
          <SrBox padding="28px 0 12px">
            <SrButton
              theme={SR_BUTTON_THEME_ADOBE_GREEN}
              disabled={!formikBag.isValid}
              heightType={SR_BUTTON_HEIGHT_MEDIUM}
              hasBoxShadow
              type="submit"
            >
              Submit
            </SrButton>
          </SrBox>
        </Form>
      )}
    />
  );
};

UPIngestServiceAreaForm.propTypes = {
  utilityTypes: PropTypes.array.isRequired,
  afterSubmit: PropTypes.func,
};

UPIngestServiceAreaForm.displayName = 'UPIngestServiceAreaForm';

export default UPIngestServiceAreaForm;
